import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import {
  GetOptimizationStatusQuery,
  GetOptimizationStatusQueryVariables,
  OptimizationStatus,
} from '../../generated/graphql';

export const optimizationStatusQuery: TypedDocumentNode<
  GetOptimizationStatusQuery,
  GetOptimizationStatusQueryVariables
> = gql`
  query GetOptimizationStatus {
    optimizationStatus {
      id
      isAuthorized
      authorizedFeatures
      optimizedContractIds
    }
  }
`;

export function useOptimizationStatus(): OptimizationStatus | undefined {
  return useQuery(optimizationStatusQuery, {}).data?.optimizationStatus;
}
